<tt-page>
    <tt-list class="col-xs-12 col-md-4 sp-0" [ttData]="itemsListStockBatches"></tt-list>
</tt-page>
